var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.98755C7 8.6547 8.08048 7.57422 9.41333 7.57422H38.5867C39.9195 7.57422 41 8.6547 41 9.98755V39.1608C41 40.4936 39.9195 41.5741 38.5867 41.5741H9.41333C8.08049 41.5741 7 40.4936 7 39.1608V9.98755Z",
    fill: "#0A66C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6331 18.1329C16.262 18.1329 17.5826 16.8123 17.5826 15.1834C17.5826 13.5544 16.262 12.2339 14.6331 12.2339C13.0041 12.2339 11.6836 13.5544 11.6836 15.1834C11.6836 16.8123 13.0041 18.1329 14.6331 18.1329Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2838 20.3126H25.1721V22.552C25.1721 22.552 26.4986 19.899 30.1078 19.899C33.3273 19.899 35.9944 21.485 35.9944 26.3194V36.5137H30.9288V27.5547C30.9288 24.7028 29.4063 24.3892 28.2461 24.3892C25.8383 24.3892 25.4261 26.466 25.4261 27.9266V36.5137H20.2838V20.3126Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0619 20.3126H17.2042V36.5137H12.0619V20.3126Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInBlue);
export default __webpack_public_path__ + "static/media/linkedIn-blue.0b80755348a57b41a752af3bc16f8c27.svg";
export { ForwardRef as ReactComponent };